module.exports = __webpack_public_path__ + "media/images/emblems/San_Vittore_wappen-ddb872e52fb64df1670078495e01fd72.svg";